import { render, staticRenderFns } from "./AddBudget.vue?vue&type=template&id=57bb2270"
import script from "./AddBudget.vue?vue&type=script&lang=js"
export * from "./AddBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports